import { UtilitiesService } from './../../services/utilities.service';
import { Component, Input, AfterViewInit, forwardRef, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, NG_VALIDATORS } from '@angular/forms';
import * as VMasker from 'vanilla-masker';

@Component({
    selector: 'tr-step-input' ,
    templateUrl: './tr-step-input.component.html',
    styleUrls: [ './tr-step-input.component.scss' ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TrStepInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: TrStepInputComponent,
            multi: true,
        },
    ],
    encapsulation: ViewEncapsulation.None,
})
export class TrStepInputComponent implements AfterViewInit, ControlValueAccessor, OnInit {

    @Input() public errorMessage: string;
    @Input() public precision = 0;
    @Input() public label: string;
    @Input() public step: number = 1;
    @Input() public sufix: string = '';

    @Input() set min(min: number) {
        if (this.isDefinedNumber(this._max)) {
            this._min = Math.min(min, this._max);
            this._max = Math.max(min, this._max);
        } else {
            this._min = min;
        }
        this.validateFunction = this.createCounterRangeValidator(this._max, this._min);
    }

    @Input() set max(max: number) {
        if (this.isDefinedNumber(this._min)) {
            this._min = Math.min(max, this._min);
            this._max = Math.max(max, this._min);
        } else {
            this._max = max;
        }
        this.validateFunction = this.createCounterRangeValidator(this._max, this._min);
    }

    @Input() public set value(value: number) {
        this._value = value;
        this.propagateChange(this._value);
    }

    public get value(): number {
        return this._value;
    }

    get maskOptions() {
        if (this.sufix && this.sufix.length > 0) {
            return { prefix: '', thousands: '.', decimal: ',', align: 'left', precision: this.precision, suffix: ` ${this.sufix}` };
        }
        return { prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', suffix: ` ${this.sufix}` };
    }

    get isValid(): boolean {
        return this._value <= this._max && this._value >= this._min;
    }

    get enableIncrementButton(): boolean {
        return (this._value + (+this.step)) <= this._max;
    }

    get enableDecrementButton(): boolean {
        return (this._value - (+this.step)) >= this._min;
    }

    public focused: boolean;
    public componentId: string;
    public iconPlus: string = 'icon_control_plus';
    public iconMinus: string = 'icon_control_minus';
    public touched: boolean = false;
    // tslint:disable-next-line:variable-name
    private _min = -Infinity;
    // tslint:disable-next-line:variable-name
    private _max = Infinity;
    // tslint:disable-next-line:variable-name
    private _value: number;
    private validateFunction: (...args: any[]) => {};

    constructor(
        private utilitiesService: UtilitiesService,
        private containerReference: ElementRef,
    ) {
        this.componentId = 'tr-input-step-' + this.utilitiesService.guid();
    }

    /**
     * Incrementa o valor do componente segundo o passo (step) definido
     */
    public increment() {
        const sum = +((this._value + (+this.step)).toFixed(2));
        if (sum <= this._max) {
            this._value = sum;
            this.propagateChange(this._value);
        }
    }

    /**
     * Decrementa o valor do componente segundo o passo (step) definido
     */
    public decrement() {
        const result = +((this._value - this.step).toFixed(2));
        if (result >= this._min) {
            this._value = result;
            this.propagateChange(this._value);
        }
    }

    /**
     * Handle para após o dom ter sido carregado
     */
    public ngAfterViewInit() {
        $(this.containerReference.nativeElement)
            .find('input')
            .keyup( (e) => {
                this.keypressHandler(e);
            });
    }

    /**
     * Handle quando o componente está sendo iniciado
     */
    public ngOnInit() {
        this.validateFunction = this.createCounterRangeValidator(this._max, this._min);
    }

    /**
     * Valida o valor do controle(chamada pelo angular)
     */
    public validate(c: FormControl) {
        return this.validateFunction(c);
    }

    /** Form Integration Interface */
    public writeValue(value: any) {
        if (value !== undefined) {
            this.value = value;
        }
    }

    /**
     * Propaga o valor para o form
     */
    // tslint:disable-next-line:no-empty
    public propagateChange = (_: any) => { };

    public registerOnChange(fn) {
        this.propagateChange = fn;
    }

    /**
     * Disparado quando o controle e tocado
     */
    public registerOnTouched() {
        //
    }

    /**
     * Cria a função que valida o range definido para o componente.
     * @param maxValue Limite superior
     * @param minValue Limite inferior
     */
    public createCounterRangeValidator(maxValue, minValue) {

        return function validateCounterRange(c: FormControl) {
            const err = {
                rangeError: {
                    given: c.value,
                    max: maxValue,
                    min: minValue,
                },
            };
            return (c.value > +maxValue || c.value < +minValue) ? err : null;
        };
    }

    /**
     * handle para capturar teclas das setas pressionadas
     * @param event evento a ser tratado
     */
    public keypressHandler(event: any) {
        if (event.which === 40) this.decrement();
        if (event.which === 38) this.increment();
    }

    public focusOutHandler(event: Event) {
        this.touched = true;
        this.focused = false;
    }

    public focusInHandler(event: Event) {
        this.focused = true;
    }

    public clickHandler(event: Event) {
        if (!this.focused) {
            event.stopPropagation();
            $(this.containerReference.nativeElement)
                .find('input')
                .focus();
        }
    }

    /**
     * Verifica se um valor fornecido é do tipo number
     * @param value valor a ser testado
     */
    private isDefinedNumber(value: any) {
        return typeof value === 'number' ? true : false;
    }
}
